const Indigo = {
  Indigo: {
    _000: '#EEF2FF',
    _500: '#6366F1',
  },
};

export default Indigo;
